import { render } from "./GamificationNotificationProfile.vue?vue&type=template&id=4a69c0e0"
import script from "./GamificationNotificationProfile.vue?vue&type=script&lang=js"
export * from "./GamificationNotificationProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__